import ProtectedRoute from 'components/ProtectedRoute'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Redirect } from 'react-router-dom'
import OrderFeedback from 'scenes/OrderFeedback'
import ActivationRateReport from './ActivationRateReport'
import DetailReport from './ActivationRateReport/ActivationFunnel/DetailReport'
import { stagesWithDetailedReport } from './ActivationRateReport/ActivationFunnel/helpers'
import AppDownloadReport from './AppDownloadReport'
import AverageCheckReport from './AverageCheckReport'
import CaptureRateReport from './CaptureRateReport'
import CustomerReport from './CustomerReport'
import DailyActivityReport from './DailyActivityReport'
import DigitalOrderingReport from './DigitalOrderingReport'
import EngagementReport from './EngagementReport'
import FrequencyReport from './FrequencyReport'
import MembershipOverviewReport from './MembershipOverviewReport'
import NpsReport from './NpsReport'
import OrderRatingsReport from './OrderFeedbackReport'
import OrderingConversionReport from './OrderingConversionReport'
import OrderingErrorReport from './OrderingErrorReport'
import PromoCodeReport from './PromoCodeReport'
import PurchasesReport from './PurchasesReport'
import RatingDetailOrInboxRedirect from './RatingDetailOrInboxRedirect'
import RetentionRateReport from './RetentionRateReport'
import RevenueReport from './RevenueReport'
import RewardActivityReport from './RewardActivityReport'
import SuppressionsReport from './Suppressions'
import TiersReport from './TiersReport'

const ReportsRouter: React.FC = () => {
  return (
    <Switch>
      <Route path="/reports/customer" component={CustomerReport} />
      <Route
        path={`/reports/lifecycle/:stage(${stagesWithDetailedReport.join(
          '|'
        )})`}
        component={DetailReport}
      />
      <Route
        path="/reports/lifecycle"
        component={() => (
          <Redirect to={'/reports/activation#activation_funnel'} />
        )}
      />
      <Route path={'/reports/revenue'} component={RevenueReport} />
      <Route path="/reports/capture_rate" component={CaptureRateReport} />
      <Route path="/reports/activation" component={ActivationRateReport} />
      <Route path="/reports/engagement" component={EngagementReport} />
      <Route path="/reports/tiers" component={TiersReport} />
      <Route path="/reports/retention_rate" component={RetentionRateReport} />
      <Route path="/reports/average_check" component={AverageCheckReport} />
      <Route path="/reports/frequency" component={FrequencyReport} />
      <Route path="/reports/promo_codes" component={PromoCodeReport} />
      {/* BEFORE the non-exact /reports/feedback route below — this is a Switch,
          so NpsReport would otherwise swallow the nested path. Kept for links
          bookmarked before the detail page moved under /order_feedback: the
          same component, behind the same Feedback gate (accessType pinned to
          'access' so it matches with RBAC off too), which re-checks the ability
          itself. */}
      <ProtectedRoute
        exact
        path="/reports/feedback/ratings/:ratingId"
        redirect="/reports/feedback#details"
        resource="Feedback"
        accessType="access"
        component={RatingDetailOrInboxRedirect}
      />
      <Route path="/reports/feedback" component={NpsReport} />
      {/* Same Switch-ordering constraint as the pair above: the exact nested
          ratings path has to be declared before the non-exact parent, or the
          OrderFeedback page below (this deep link's page, unaffected by the
          route swap below it) swallows it. */}
      <ProtectedRoute
        exact
        path="/order_feedback/ratings/:ratingId"
        redirect="/order_feedback#feedback"
        resource="Feedback"
        accessType="access"
        component={RatingDetailOrInboxRedirect}
      />
      {/* /order_feedback serves the Order feedback page (Overview/Feedback/
          Settings) rather than the Looker report, which moved to
          /order_ratings below. The two nexus mailers that link here both
          keep working under this swap — see the PR description. */}
      <Route path="/order_feedback" component={OrderFeedback} />
      <Route path="/order_ratings" component={OrderRatingsReport} />
      <Route
        path="/reports/membership_overview"
        component={MembershipOverviewReport}
      />
      <Route
        path="/reports/ordering_conversion"
        component={OrderingConversionReport}
      />
      <Route
        path="/reports/ordering_error_report"
        component={OrderingErrorReport}
      />
      <Route path="/reports/app_downloads" component={AppDownloadReport} />
      <Route
        path="/reports/digital_ordering"
        component={DigitalOrderingReport}
      />
      <Route path={'/reports/purchases'} component={PurchasesReport} />
      <Route path="/reports/daily_activity" component={DailyActivityReport} />
      <Route path="/reports/reward_activity" component={RewardActivityReport} />
      <Route path="/reports/suppressions" component={SuppressionsReport} />
    </Switch>
  )
}

export default ReportsRouter
